import { Switch } from 'react-router-dom'
import RouteMiddleware from 'src/components/common/RouteMiddleware'
import TermsAndConditions from 'src/components/BuyPolicy/insuranceScreens/health/TermsAndConditions'
import MedicalCondition from 'src/components/BuyPolicy/insuranceScreens/health/MedicalCondition'
import { makeStyles } from '@material-ui/core/styles'
import Tip from 'src/components/BuyPolicy/insuranceScreens/health/Tip'
import { COLORS } from 'src/utils/Themes/colors'
import ContactUs from 'src/components/BuyPolicy/insuranceScreens/health/ContactUs'
import FamilyMemberDetails from 'src/components/BuyPolicy/insuranceScreens/health/FamilyMemberDetails'
import MemberDetailsForm from 'src/components/BuyPolicy/insuranceScreens/health/MemberDetailsForm'
import PlanDetails from 'src/components/BuyPolicy/insuranceScreens/health/PlanDetails/PlanDetails'
import HealthInsuranceDetails from 'src/components/BuyPolicy/insuranceScreens/health/HealthInsuranceDetails'
import PriceDetails from 'src/components/BuyPolicy/insuranceScreens/health/PriceDetails'
import { getUrlLastRoute } from 'src/utils/commonMethods'
import React from 'react'
import ComparePolicies from 'src/components/BuyPolicy/insuranceScreens/health/ComparePolicies'
import { HEALTH_ROUTES } from 'src/utils/constants/BuyPolicy'

const HealthInsuranceDetailsLayout = () => {
  const classes = useStyles()
  const urlLastRoute = getUrlLastRoute()
  const getQuoteCard = () => {
    return (
      urlLastRoute?.includes(HEALTH_ROUTES?.memberDetailsForm) ||
      urlLastRoute?.includes(HEALTH_ROUTES?.medicalCondition) ||
      urlLastRoute?.includes(HEALTH_ROUTES?.termsAndConditions) ||
      urlLastRoute?.includes(HEALTH_ROUTES?.planDetails)
    )
  }

  const showTip = () => {
    return urlLastRoute?.includes(HEALTH_ROUTES?.insuranceDetails)
  }

  const showContactUs = () => {
    return (
      urlLastRoute?.includes(HEALTH_ROUTES?.insuranceDetails) ||
      urlLastRoute?.includes(HEALTH_ROUTES?.planDetails)
    )
  }

  const showComparePolicies = () => {
    return urlLastRoute?.includes(HEALTH_ROUTES?.insuranceDetails)
  }

  return (
    <>
      <div className={'component-container'}>
        <div className={'component-element'}>
          <div className={classes.layout}>
            <div className={classes.insuranceDetailsContainer}>
              <Switch>
                <RouteMiddleware
                  title={'Terms And Conditions'}
                  path='/individual/dashboard/buyPolicy/health/insuranceDetails/terms-and-conditions'
                  component={TermsAndConditions}
                />
                <RouteMiddleware
                  title={'Medical Condition'}
                  path='/individual/dashboard/buyPolicy/health/insuranceDetails/medical-condition'
                  exact
                  component={MedicalCondition}
                />
                <RouteMiddleware
                  title={'Member Details Form'}
                  path='/individual/dashboard/buyPolicy/health/insuranceDetails/member-details'
                  exact
                  component={MemberDetailsForm}
                />
                <RouteMiddleware
                  title={'Plan Details'}
                  path='/individual/dashboard/buyPolicy/health/insuranceDetails/plan-details'
                  exact
                  component={PlanDetails}
                />
                <RouteMiddleware
                  title={'Insurance Details'}
                  path='/'
                  component={HealthInsuranceDetails}
                />
              </Switch>
            </div>
            <div className={classes.otherDetailsContainer}>
              <FamilyMemberDetails />
              {showTip() && <Tip />}
              {getQuoteCard() && <PriceDetails />}
              {showContactUs() && <ContactUs />}
            </div>
          </div>
        </div>
        {showComparePolicies() && <ComparePolicies />}
      </div>
    </>
  )
}

export default HealthInsuranceDetailsLayout

const useStyles = makeStyles({
  layout: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    backgroundColor: COLORS.WHITE,
  },
  insuranceDetailsContainer: {
    width: '70%',
    display: 'flex',
    flexDirection: 'row',
  },
  otherDetailsContainer: {
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
})
